/* eslint-disable @wordpress/dependency-group */
import $ from 'jquery';
import domReady from '@wordpress/dom-ready';

import './inc/responsive-menus';
import toggleBusiness from './inc/toggleBusiness';
import toggleFooterMenu from './inc/toggleFooterMenu';
import toggleSearchForm from './inc/toggleSearchForm';
import setCSSVariable from './inc/setInlineCssVars';
import toggleBodyClassOnScroll from './inc/detect-scroll';
import trackImageWidth from '../helpers/track-image-width';
import megaMenu from './inc/megaMenu';
import toastNotices from './inc/toast-notices';

// window.addEventListener( 'DOMContentLoaded', () => {
// 	console.log( 'DOMContentLoaded' );
// 	// setCSSVariable.init();
// } );

// window.addEventListener( 'resize', () => {
// 	console.log( 'resize' );
// 	setCSSVariable.init();
// } );
// } );

window.addEventListener( 'orientationchange', () => {
	// console.log( 'orientationchange' );
	setCSSVariable.init();
} );

window.addEventListener( 'load', () => {
	// console.log( 'load' );
	setCSSVariable.init();
	megaMenu.init();
	const theBody = document.body;
	// eslint-disable-next-line no-undef
	const resizeObserver = new ResizeObserver( ( entries ) => {
		// eslint-disable-next-line no-unused-vars
		for ( const entry of entries ) {
			toggleBodyClassOnScroll( 'scrolling' );
		}
	} );
	theBody.classList.add( 'js-loaded' );
	resizeObserver.observe( theBody );
	// setCSSVariable.init();
} );

domReady( function () {
	const catImgs = [
		...document.querySelectorAll(
			'.products-categories-list-item-image img'
		),
	];
	const prodImgs = [ ...document.querySelectorAll( '.product-image img' ) ];
	const ctaImgs = [
		...document.querySelectorAll( '.showroom-cta-visual img' ),
	];
	const aboutUsImgs = [
		...document.querySelectorAll( '.about-us-box-image' ),
	];
	const mediaTextImgs = [
		...document.querySelectorAll(
			'.is-style-licht-concept-about .wp-block-media-text__media'
		),
	];
	const mediaTextStackedImgs = [
		...document.querySelectorAll(
			'.is-style-licht-concept-stacked-about .wp-block-media-text__media'
		),
	];

	catImgs.forEach( ( catImg ) => {
		trackImageWidth( catImg, '--img-border-radius' );
	} );
	prodImgs.forEach( ( prodImg ) => {
		trackImageWidth( prodImg, '--img-border-radius' );
	} );
	ctaImgs.forEach( ( ctaImg ) => {
		trackImageWidth( ctaImg, '--img-border-radius' );
	} );
	aboutUsImgs.forEach( ( aboutImg ) => {
		trackImageWidth( aboutImg, '--img-border-radius', 20 );
	} );
	if ( mediaTextImgs ) {
		mediaTextImgs.forEach( ( mediaImg ) => {
			trackImageWidth( mediaImg, '--img-border-radius' );
		} );
	}
	if ( mediaTextStackedImgs ) {
		mediaTextStackedImgs.forEach( ( mediaImg ) => {
			trackImageWidth( mediaImg, '--img-border-radius' );
		} );
	}

	toggleBusiness.init();
	toastNotices.init();
	toggleFooterMenu.init();
	toggleSearchForm.init();
} );
